import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import shopeebasesetting from './modules/shopeebasesetting'
import orderStatistics from './modules/order-statistics'
import erporderStatistics from './modules/order-erpstatistics'
import channel from './modules/channelmaintain'
import pddtoken from './modules/pddtokenmanagement'
import promote from './modules/pddpromote'
import config from './modules/configurantionsetting'
import figtenant from './modules/configurationtenant'
import tenantsetting from './modules/tenantsetting'
import seeconfig from './modules/seeproductsetting'
const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        pddtoken,
        account,
        user,
        role,
        tenant,
        shopeebasesetting,
        orderStatistics,
        channel,
        promote,
        //channel,
        config,
        figtenant,
        tenantsetting,
        seeconfig,
        erporderStatistics
    }
});

export default store;